export default "__VITE_ASSET__B_dQkDu8__"